module.exports = __webpack_public_path__ + "media/src/images/arrow_left_on-44dd7b80f02813da60a302ea215a9afc.png";